import { render, staticRenderFns } from "./parts-edit.vue?vue&type=template&id=455c9af2&scoped=true"
import script from "./parts-edit.vue?vue&type=script&lang=ts"
export * from "./parts-edit.vue?vue&type=script&lang=ts"
import style0 from "./parts-edit.vue?vue&type=style&index=0&id=455c9af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c9af2",
  null
  
)

export default component.exports